export enum InputValueType
{
    string,
    number,
    boolean
}